// Shared IT Portal page catalog. Keep React components in portalPages.tsx.
// The backend workflows copy this exact file into their deployment package.
const portalPageRegistry = /** @type {const} */ ([
  {
    "key": "landscape",
    "label": "Landscape",
    "path": "/",
    "showInMenu": true,
    "group": "IT",
    "permissionLabel": "Landscape",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "flowBuilder",
    "label": "Flow Builder",
    "path": "/flow-builder",
    "showInMenu": true,
    "group": "IT",
    "permissionLabel": "Flow Builder",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "workCenter",
    "label": "Work Center",
    "path": "/work-center",
    "showInMenu": true,
    "group": "IT",
    "permissionLabel": "Work Center",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "financeIntegrations",
    "label": "Integration Monitor",
    "path": "/finance/integraties/softpak-afas",
    "showInMenu": true,
    "menuGroup": "Integraties",
    "group": "Finance",
    "permissionLabel": "Finance – Integration Monitor",
    "assignable": true,
    "requiredRole": "user",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "integrationCenter",
    "label": "Integration Architect",
    "path": "/integrations/*",
    "showInMenu": true,
    "menuGroup": "Integraties",
    "group": "Finance",
    "permissionLabel": "Finance – Integration Architect",
    "assignable": true,
    "requiredRole": "user",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "salesQuoteAutomation",
    "label": "Automatisch quotes aanmaken",
    "path": "/sales/quotes/automatisch-aanmaken",
    "showInMenu": true,
    "menuGroup": "Quotes",
    "group": "Sales",
    "permissionLabel": "Sales – Automatisch quotes aanmaken",
    "assignable": true,
    "requiredRole": "user",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "import",
    "label": "Overzicht",
    "path": "/import",
    "showInMenu": true,
    "group": "Import",
    "permissionLabel": "Import – Overzicht",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "importAutomation",
    "label": "Automatisering",
    "path": "/import/automatisering",
    "showInMenu": true,
    "group": "Import",
    "permissionLabel": "Import – Automatisering",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "mailRules",
    "label": "Mailregels",
    "path": "/import/mailregels",
    "showInMenu": true,
    "group": "Import",
    "permissionLabel": "Import – Mailregels",
    "assignable": true,
    "requiredRole": "admin",
    "menuGroup": "",
    "adminOnly": true,
    "superadminOnly": false
  },
  {
    "key": "carrierIntegrations",
    "label": "Carrier Integrations",
    "path": "/carrier-integrations",
    "showInMenu": true,
    "adminOnly": true,
    "group": "IT",
    "permissionLabel": "Carrier Integrations",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "superadminOnly": false
  },
  {
    "key": "logicAppMonitor",
    "label": "Logic Monitor",
    "path": "/logic-monitor",
    "showInMenu": true,
    "adminOnly": true,
    "group": "IT",
    "permissionLabel": "Logic Monitor",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "superadminOnly": false
  },
  {
    "key": "createPortal",
    "label": "Customer Portal Admin",
    "path": "/portal-factory/create",
    "showInMenu": true,
    "adminOnly": true,
    "group": "Operations",
    "permissionLabel": "Customer Portal Admin",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "superadminOnly": false
  },
  {
    "key": "agenciesInkoopInvoices",
    "label": "Agencies inkoopfacturen",
    "path": "/operations/agencies-inkoopfacturen",
    "showInMenu": true,
    "group": "Operations",
    "permissionLabel": "Operations – Agencies inkoopfacturen",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "adminSettings",
    "label": "Admin Page",
    "path": "/admin-settings",
    "showInMenu": true,
    "adminOnly": true,
    "group": "",
    "permissionLabel": "Admin Page",
    "assignable": false,
    "requiredRole": "user",
    "menuGroup": "",
    "superadminOnly": false
  },
  {
    "key": "comboKeyChecker",
    "label": "Sanctielijst",
    "path": "/combo-key-checker",
    "showInMenu": true,
    "group": "Operations",
    "permissionLabel": "Sanctielijst – Snelle controle",
    "assignable": true,
    "requiredRole": "user",
    "menuGroup": "",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "comboKeyApprovals",
    "label": "Combo Keys beoordelen",
    "path": "/combo-key-approvals",
    "showInMenu": false,
    "group": "",
    "permissionLabel": "Sanctielijst – Combo Keys beoordelen",
    "assignable": true,
    "requiredRole": "admin",
    "menuGroup": "",
    "adminOnly": false,
    "superadminOnly": false
  },
  {
    "key": "internalUserManagement",
    "label": "Gebruikersbeheer",
    "path": "/gebruikersbeheer",
    "showInMenu": true,
    "superadminOnly": true,
    "group": "IT",
    "permissionLabel": "Gebruikersbeheer",
    "assignable": false,
    "requiredRole": "user",
    "menuGroup": "",
    "adminOnly": false
  }
]);

const assignablePortalPages = portalPageRegistry.filter((page) => page.assignable && !page.superadminOnly);

/** @param {string} key */
function getPortalPage(key) {
  return portalPageRegistry.find((page) => page.key === key);
}

/** @param {string} key @param {string | null} role */
function canAssignPortalPage(key, role) {
  const page = getPortalPage(key);
  return Boolean(page && page.assignable && !page.superadminOnly &&
    (page.requiredRole !== "admin" || role === "admin"));
}

module.exports = { portalPageRegistry, assignablePortalPages, getPortalPage, canAssignPortalPage };
